import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'arrowRight',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-arrow-right wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M10.525 5.263a.506.506 0 0 1 .003-.71l.7-.701a.495.495 0 0 1 .711-.003l7.778 7.777a.5.5 0 0 1 .144.352.48.48 0 0 1-.144.356l-7.778 7.778a.506.506 0 0 1-.71-.003l-.701-.7a.495.495 0 0 1-.003-.711l5.702-5.703H4.6a.505.505 0 0 1-.5-.505v-.99c0-.29.224-.505.5-.505h11.657z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-arrow-right.svg',
    category: 'Core',
    tags: ['forward', 'navigation', 'ui'],
};
export default icon;
